import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout';
import { Home } from './components/home';
import { AboutUs } from './components/aboutus';
import { DataSubjectRequest } from './components/datasubjectrequest';
import { VerifyRequest } from './components/verifyrequest';
import { ConsentManagement } from './components/consentmanagement';
import { DataSubjectRequestList } from './components/datasubjectrequestlist';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { InactivePlan } from './components/inactiveplan';
import { OrgSettingsProvider, useOrgSettings } from './contexts/OrgSettingsContext';
import { ConfirmProvider } from './components/confirm';
import { TooltipProvider } from './components/ui';

function AppContent() {
  const { settings, isLoading, isError } = useOrgSettings();

  useEffect(() => {
    if (settings) {
      // Update favicon
      const favicon = document.getElementById('favicon') as HTMLLinkElement;
      if (favicon) {
        favicon.href = settings.faviconIconPath || '#';
      }

      // Initialize Application Insights
      if (settings.instrumentationKey && settings.instrumentationKey !== '') {
        const appInsights = new ApplicationInsights({
          config: {
            instrumentationKey: settings.instrumentationKey,
          },
        });
        appInsights.loadAppInsights();
        appInsights.trackPageView();
      }
    }
  }, [settings]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <div className="animate-pulse flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-gray-200" />
          <div className="h-4 w-32 bg-gray-200 rounded" />
        </div>
      </div>
    );
  }

  if (isError) {
    return <InactivePlan />;
  }

  return (
    <TooltipProvider>
      <ConfirmProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/datasubjectrequest" element={<DataSubjectRequest />} />
            <Route path="/consentmanagement" element={<ConsentManagement />} />
            <Route path="/verifyrequest" element={<VerifyRequest />} />
            <Route path="/datasubjectrequestlist" element={<DataSubjectRequestList />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </ConfirmProvider>
    </TooltipProvider>
  );
}

export default function App() {
  return (
    <OrgSettingsProvider>
      <AppContent />
    </OrgSettingsProvider>
  );
}
